<template>
  <b-modal
    id="invest-topup-modal"
    centered
    title="Top up your wallet"
    @hide="resetData"
    ref="top_up_modal"
  >
    <div class="modal-wrap">
      <b-row class="overflow-hidden">
        <b-col cols="12">
          <p>You can topup a minimum of ₦100</p>
          <b-form class="mt-2" @submit="openPaystack" @input="formInput">
            <b-form-group
              label="Amount"
              :invalid-feedback="formErrors.amount"
              :state="fieldState.amount"
            >
              <b-form-input
                id="amount"
                v-model="form.amount"
                :state="fieldState.amount"
                type="number"
                required
                placeholder="Minimum of ₦100"
              ></b-form-input>
            </b-form-group>
          </b-form>
        </b-col>
        <div
          class="overlay-load position-absolute w-100 h-100 d-flex align-items-center justify-content-center"
          style="top:0;left:0;z-index:10;background-color:rgba(255,255,255,0.7)"
          v-if="submitting"
        >
          <b-spinner label="Small Spinner"></b-spinner>
        </div>
      </b-row>
    </div>
    <template v-slot:modal-footer="{ ok, cancel }">
      <b-button variant="light" @click="cancel()">Cancel</b-button>
      <StatefulButton
        :error="error"
        :loading="submitting"
        loadingText="Topping up..."
        text="Top Up"
        variant="primary"
        @click="openPaystack"
      />
    </template>
    <paystack
      :amount="form.amount * 100"
      :email="userObj.email"
      :paystackkey="paystackKey"
      reference
      :callback="paystackCallback"
      :close="paystackClose"
      :embed="false"
    ></paystack>
  </b-modal>
</template>

<script>
import { mapState } from "vuex";
import paystack from "vue-paystack";
import StatefulButton from "@/components/actions/StatefulButton";

import { checkFormErrors, validateDigits } from "@/utils/validators";
import { TransactionService } from "@/services";

export default {
  name: "topup-modal",
  data() {
    return {
      form: {
        amount: null
      },
      formErrors: {},
      error: false,
      submitting: false,
      paystackKey: process.env.VUE_APP_PAYSTACK_KEY
    };
  },
  components: {
    StatefulButton,
    paystack
  },
  computed: {
    ...mapState(["userObj"]),
    fieldState() {
      return checkFormErrors(this.formErrors);
    }
  },
  methods: {
    async openPaystack(event) {
      event.preventDefault();
      const { amount } = this.form;
      if (!this.form.amount) {
        this.formErrors = { amount: "Amount is required" };
        this.error = true;
        return;
      }
      const res = validateDigits(amount, "amount");
      if (!res.valid) {
        this.formErrors = res.errors;
        this.error = true;
        return;
      }

      if (amount < 100) {
        this.formErrors = { amount: "Minimum amount is ₦100" };
        this.error = true;
        return;
      }
      const btn = document.querySelector(".payButton");
      btn.click();
    },
    async paystackCallback(response) {
      const { reference } = response;
      this.submitting = true;
      // try {
      const { message } = await TransactionService.topUp(reference);
      this.$store.dispatch("toast", {
        message
      });
      this.$refs.top_up_modal.hide();
      this.submitting = false;
      setTimeout(() => {
        location.reload();
      }, 1000 * 1.5);
      // } catch (err) {
      // console.error(err);
      // } finally {
      // }
    },
    paystackClose() {},
    formInput(event) {
      event.preventDefault();
      this.error = false;
      this.formErrors = {};
    },
    resetData() {
      Object.assign(this.$data, this.$options.data.apply(this));
    }
  }
};
</script>
